import { FC } from 'react';
import { Text, View } from '@react-pdf/renderer';

import Table from '../PdfTable';
import styles from './styles';

interface InterestsProps {
  taxYear: string;
  interests: {
    amount: number;
    formattedAmount: string;
  };
  totalAmount: string;
}

const Interests: FC<InterestsProps> = ({ taxYear, interests, totalAmount }) => {
  if (!interests.amount) {
    return (
      <View wrap={false}>
        <Text style={styles.heading}>Interest received</Text>
        <Text style={styles.paragraph}>
          You did not receive any interest payments during the {taxYear} tax
          year.
        </Text>
      </View>
    );
  }

  return (
    <>
      <View wrap={false}>
        <Text style={styles.heading}>Interest received</Text>
        <Text style={styles.paragraph}>
          You received the following taxable interest during this tax year:
        </Text>
      </View>

      <Table
        title={null}
        backgroundColor="white"
        fontColor="#333333"
        alignContent="left"
        fontSize={8}
        fullBorder
        collapseFooterBorderBottomWhenEmptyValue
        expandRows
        columns={{
          investment: { value: 'Description', bold: true },
          amount: {
            value: 'Interest amount',
            bold: true,
            width: 22,
          },
        }}
        data={[
          {
            investment: {
              value: `Interest - ${taxYear}`,
            },
            amount: {
              value: interests.formattedAmount,
              width: 22,
            },
          },
        ]}
        footer={{
          investment: {
            value: '',
          },
          investmentDate: {
            value: '',
            width: 22,
          },
          interestsPaymentDate: {
            value: '',
            width: 22,
          },
          amount: {
            value: totalAmount,
            bold: true,
            width: 22,
          },
        }}
      />
      <Text style={[styles.paragraph, styles.topMargin]}>
        The above interest should be included in your tax return this year. To
        see the individual interest payments that comprise your total interest,
        please visit your ‘My cash balance’ page, which can be found in the menu
        of your portal.
      </Text>
      <Text style={styles.paragraph}>
        If you pay tax in a non-UK jurisdiction, please seek professional tax
        advice before deciding which of the above interest payments are subject
        to tax in your applicable jurisdiction.
      </Text>
    </>
  );
};

export default Interests;
